export default {
  state: {
    activityTabs: {}
  },
  getters: {},
  mutations: {
    setActivityTabs (state, tabs) {
      state.activityTabs = tabs
    }
  }
}
